import React, { useEffect, useState, useCallback } from "react";
import useCurrentUser from "../../../hooks/useCurrentUser";
import useContestSettings from "../../../hooks/useContestSettings";
import useAppContext from "../../../hooks/useAppContext";

import CommentsContainer from "../../../components/comments/container/container.component";

const CommentsWrapper = () => {
  const [comments, setComments] = useState([]);
  const [meta, setMeta] = useState({});
  const [filterObject, setFilterObject] = useState({
    page: 1,
    limit: 3,
    order: "by_created_at_desc",
  });
  const {
    data: { slug, showComments, commentsReadonly },
  } = useContestSettings();
  const currentUser = useCurrentUser();
  const { axios } = useAppContext();

  const fetchComments = useCallback(
    (callback = undefined) => {
      axios
        .get(`contests/${slug}/comments`, {
          params: {
            ...filterObject,
          },
        })
        .then((res) => {
          setComments(res.data.data);
          setMeta(res.data.meta);
          if (callback) callback();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    [slug, filterObject],
  );

  useEffect(() => {
    if (!showComments) return;

    fetchComments();
  }, [filterObject, slug]);

  const handlePostComment = useCallback(
    (comment, parentId = null, callback = undefined) => {
      const payoad = parentId
        ? { body: comment, parent_id: parentId }
        : { body: comment };
      let success = false;
      axios
        .post(`contests/${slug}/comments`, {
          comment: {
            ...payoad,
          },
        })
        .then(() => {
          fetchComments(callback);
          success = true;
        })
        .catch((err) => {
          console.log(err);
        });

      return success;
    },
    [slug],
  );

  const setPage = (page) => {
    setFilterObject({ ...filterObject, page: page });
  };

  const setOrder = (order) => {
    setFilterObject({ ...filterObject, order: order, page: 1 });
  };

  return (
    <>
      {showComments ? (
        <CommentsContainer
          data={comments}
          metaData={meta}
          commentsReadonly={commentsReadonly}
          handlePostComment={handlePostComment}
          order={filterObject.order}
          setOrder={setOrder}
          setComments={setComments}
          setPage={setPage}
        />
      ) : (
        !currentUser && (
          <div style={{ textAlign: "center", padding: "40px 0" }}>
            <h3>Login to view and post comments.</h3>
          </div>
        )
      )}
    </>
  );
};

export default CommentsWrapper;
